import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class DriverQuoteEntryValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		const properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		const validator = this.getValidator();
		this.message = '';
		let result = true;

		if (properties.find(p => p === 'driver') != null) {
			const driver: any = dynamicProperties['driver'] as any;
			if (!validator.isNotEmpty(driver)) {
				this.message = this.message.concat('Car rent reservations requires a driver <br />');
				result = false;
			}
		}

		if (properties.find(p => p === 'officePickupId') != null) {
			const officePickupId: any = dynamicProperties['officePickupId'] as any;
			if (!validator.isNotEmpty(officePickupId)) {
				this.message = this.message.concat('Pickup field is required <br />');
				result = false;
			}
		}
		if (properties.find(p => p === 'officeDropOffId') != null) {
			const officeDropOffId: any = dynamicProperties['officeDropOffId'] as any;
			if (!validator.isNotEmpty(officeDropOffId)) {
				this.message = this.message.concat('Drop off field is required <br />');
				result = false;
			}
		}

		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/driver-quote-entry-validator.ts